(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6682],{

/***/ 59986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BaseContentCard$1; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */





var BaseContentCard = function BaseContentCard(_ref) {
  var meta = _ref.meta,
    tags = _ref.tags,
    onClickTag = _ref.onClickTag,
    showPaywall = _ref.showPaywall,
    children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "quiver-base-content-card"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "quiver-base-content-card__meta"
  }, meta), children, !showPaywall && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("ul", {
    className: "quiver-base-content-card__tags"
  }, tags.map(function (tag) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("li", {
      key: tag.name
    }, tag.url ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
      href: tag.url,
      onClick: function onClick() {
        return onClickTag && onClickTag(tag);
      }
    }, tag.name) : tag.name);
  })));
};
BaseContentCard.defaultProps = {
  onClickTag: null,
  showPaywall: false
};
var BaseContentCard$1 = BaseContentCard;


//# sourceMappingURL=BaseContentCard.js.map


/***/ }),

/***/ 14832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContentCardPaywall$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _surfline_quiver_assets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20120);
/* harmony import */ var _icons_PremiumTagLarge_PremiumTagLarge_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95963);
/* harmony import */ var _Button_Button_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25874);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */







var wavesUrl = "".concat(_surfline_quiver_assets__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, "/backgrounds/paywall-background.png");
var ContentCardPaywall = function ContentCardPaywall(_ref) {
  var funnelUrl = _ref.funnelUrl,
    onClick = _ref.onClick;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-content-card__paywall",
    style: {
      backgroundImage: "url(".concat(wavesUrl, ")")
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_icons_PremiumTagLarge_PremiumTagLarge_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h5", {
    className: "quiver-content-card__paywall__message"
  }, "Want access to Premium Analysis from the Surfline forecast team?"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Button_Button_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    href: funnelUrl,
    onClick: onClick
  }, "Start Free Trial"));
};
ContentCardPaywall.defaultProps = {
  onClick: null
};
var ContentCardPaywall$1 = ContentCardPaywall;


//# sourceMappingURL=ContentCardPaywall.js.map


/***/ }),

/***/ 63301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContentContainer$1; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */






var getClass = function getClass(rootClass) {
  return classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    'quiver-content-container': true
  }, rootClass, !!rootClass));
};
var ContentContainer = function ContentContainer(_ref) {
  var children = _ref.children,
    classes = _ref.classes;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: getClass(classes.root)
  }, children);
};
ContentContainer.defaultProps = {
  classes: {},
  children: null
};
var ContentContainer$1 = ContentContainer;


//# sourceMappingURL=ContentContainer.js.map


/***/ }),

/***/ 26599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EditorialArticleCard$1; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
var external_React_default = /*#__PURE__*/__webpack_require__.n(external_React_);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/BaseContentCard/BaseContentCard.js
var BaseContentCard = __webpack_require__(59986);
;// CONCATENATED MODULE: ./node_modules/@surfline/quiver-react/esm/BaseContentCardPaywall/BaseContentCardPaywall.js
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */




var BaseContentCardPaywall = function BaseContentCardPaywall(_ref) {
  var funnelUrl = _ref.funnelUrl,
    onClick = _ref.onClick,
    message = _ref.message;
  return /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-base-content-card__paywall"
  }, /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-base-content-card__paywall__message"
  }, /*#__PURE__*/external_React_default().createElement("svg", {
    viewBox: "0 0 11 13"
  }, /*#__PURE__*/external_React_default().createElement("path", {
    d: "M5.5,1 C3.47416667,1 1.83333333,2.6228022 1.83333333, 4.62637363 L1.83333333,6.43956044 L0,6.43956044 L0,13.6923077 L11, 13.6923077 L11,6.43956044 L9.16666667,6.43956044 L9.16666667, 4.62637363 C9.16666667,2.6228022 7.52583333,1 5.5,1 L5.5, 1 Z M5.5,2.81318681 C6.59083333,2.81318681 7.33333333,3.54752747 7.33333333, 4.62637363 L7.33333333,6.43956044 L3.66666667,6.43956044 L3.66666667, 4.62637363 C3.66666667,3.54752747 4.40916667,2.81318681 5.5,2.81318681 Z M4.58333333, 8.25274725 L6.41666667,8.25274725 L6.41666667,11.8791209 L4.58333333, 11.8791209 L4.58333333,8.25274725 Z"
  })), message), /*#__PURE__*/external_React_default().createElement("a", {
    className: "quiver-base-content-card__paywall__link",
    href: funnelUrl,
    onClick: onClick
  }, "Start Free Trial"));
};
BaseContentCardPaywall.defaultProps = {
  onClick: null,
  message: null
};
var BaseContentCardPaywall$1 = BaseContentCardPaywall;


//# sourceMappingURL=BaseContentCardPaywall.js.map

;// CONCATENATED MODULE: ./node_modules/@surfline/quiver-react/esm/EditorialArticleCard/EditorialArticleCard.js
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */







var getBaseContentMeta = function getBaseContentMeta(externalLink, externalSource, author, publishedDateTime) {
  var metaText = "By ".concat(author, " \u2022 ").concat(publishedDateTime);
  if (externalSource && externalLink === 'External URL') {
    metaText = "Via ".concat(externalSource, " \u2022 ").concat(publishedDateTime);
  }
  return metaText;
};
var EditorialArticleCard = function EditorialArticleCard(_ref) {
  var author = _ref.author,
    publishedDateTime = _ref.publishedDateTime,
    title = _ref.title,
    subtitle = _ref.subtitle,
    permalink = _ref.permalink,
    media = _ref.media,
    tags = _ref.tags,
    showPaywall = _ref.showPaywall,
    funnelUrl = _ref.funnelUrl,
    onClickContent = _ref.onClickContent,
    onClickPaywall = _ref.onClickPaywall,
    onClickTag = _ref.onClickTag,
    externalLink = _ref.externalLink,
    externalSource = _ref.externalSource,
    newWindow = _ref.newWindow;
  return /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-editorial-article-card"
  }, /*#__PURE__*/external_React_default().createElement(BaseContentCard/* default */.Z, {
    meta: getBaseContentMeta(externalLink, externalSource, author, publishedDateTime),
    tags: tags,
    onClickTag: onClickTag,
    showPaywall: showPaywall
  }, showPaywall ? /*#__PURE__*/external_React_default().createElement("div", null, /*#__PURE__*/external_React_default().createElement("h2", null, title), /*#__PURE__*/external_React_default().createElement(BaseContentCardPaywall$1, {
    funnelUrl: funnelUrl,
    onClick: onClickPaywall,
    message: "Unlock Premium Content"
  })) : /*#__PURE__*/external_React_default().createElement("a", {
    href: permalink,
    onClick: onClickContent,
    target: newWindow ? '_blank' : '_self',
    rel: "noreferrer"
  }, /*#__PURE__*/external_React_default().createElement("h2", null, title), /*#__PURE__*/external_React_default().createElement("p", {
    className: "quiver-editorial-article-card__subtitle"
  }, subtitle), media ? /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-editorial-article-card__media",
    style: {
      backgroundImage: "url(".concat(media.feed2x, ")")
    }
  }) : null)));
};
EditorialArticleCard.defaultProps = {
  subtitle: null,
  media: null,
  showPaywall: false,
  funnelUrl: null,
  onClickContent: null,
  onClickPaywall: null,
  onClickTag: null,
  externalLink: null,
  externalSource: null,
  newWindow: false
};
var EditorialArticleCard$1 = EditorialArticleCard;


//# sourceMappingURL=EditorialArticleCard.js.map


/***/ }),

/***/ 960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ForecastArticleBody$1; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_createAccessibleOnClick_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4336);
/* harmony import */ var _ShareArticle_ShareArticle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67997);
/* harmony import */ var _ContentCardPaywall_ContentCardPaywall_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14832);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */








var ForecastArticleBody = function ForecastArticleBody(_ref) {
  var id = _ref.id,
    title = _ref.title,
    body = _ref.body,
    showMore = _ref.showMore,
    url = _ref.url,
    showShare = _ref.showShare,
    onClickShareArticle = _ref.onClickShareArticle,
    showPaywall = _ref.showPaywall,
    onClickReadMore = _ref.onClickReadMore,
    funnelUrl = _ref.funnelUrl,
    onClickPaywall = _ref.onClickPaywall,
    showAll = _ref.showAll,
    toggleShowMore = _ref.toggleShowMore,
    CustomPaywallCTA = _ref.CustomPaywallCTA;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-forecast-article-card__body-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-forecast-article-card__body-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-forecast-article-card__body",
    dangerouslySetInnerHTML: {
      __html: body
    },
    id: id
  }), (showAll || showMore) && url && showShare ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-forecast-article-card__body__share"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "quiver-forecast-article-card__body__share__title"
  }, "Share this post"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ShareArticle_ShareArticle_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    url: url,
    onClickLink: onClickShareArticle
  })) : null, !showAll && !showPaywall ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    role: "button",
    className: "quiver-forecast-article-card__read-more-less"
  }, (0,_utils_createAccessibleOnClick_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(toggleShowMore, _utils_createAccessibleOnClick_js__WEBPACK_IMPORTED_MODULE_3__/* .BTN */ .Y8)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", (0,_utils_createAccessibleOnClick_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(onClickReadMore, _utils_createAccessibleOnClick_js__WEBPACK_IMPORTED_MODULE_3__/* .BTN */ .Y8), showMore ? 'Read Less' : 'Read More')) : null, showPaywall && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-forecast-article-card__content-fade"
  })), showPaywall && (CustomPaywallCTA ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(CustomPaywallCTA, null) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ContentCardPaywall_ContentCardPaywall_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    funnelUrl: funnelUrl,
    onClick: onClickPaywall
  })));
};
ForecastArticleBody.defaultProps = {
  id: null,
  body: '',
  showPaywall: false,
  showMore: false,
  funnelUrl: '',
  onClickPaywall: null,
  onClickReadMore: null,
  onClickShareArticle: null,
  url: '',
  showShare: true,
  showAll: true,
  toggleShowMore: null,
  CustomPaywallCTA: null
};
var ForecastArticleBody$1 = ForecastArticleBody;


//# sourceMappingURL=ForecastArticleBody.js.map


/***/ }),

/***/ 7800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ForecastArticleCard$1; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(41451);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43144);
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97326);
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60136);
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82963);
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61120);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4942);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4723);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64721);
/* harmony import */ var lodash_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _surfline_web_common__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(59075);
/* harmony import */ var _BaseContentCard_BaseContentCard_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59986);
/* harmony import */ var _ForecastArticleBody_ForecastArticleBody_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(960);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */

























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ForecastArticleCard = /*#__PURE__*/function (_Component) {
  (0,_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(ForecastArticleCard, _Component);
  var _super = _createSuper(ForecastArticleCard);
  function ForecastArticleCard(props) {
    var _this;
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(this, ForecastArticleCard);
    _this = _super.call(this, props);
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this), "applyVideoEvent", function (vid) {
      var clickedVideoIds = _this.state.clickedVideoIds;
      var segmentCategory = _this.props.segmentCategory;
      var currVid = vid;
      var contentId = lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(currVid, 'offsetParent.id', null);
      var title = lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(currVid, 'attributes.alt.value', null);
      currVid.onplay = function () {
        if (!lodash_includes__WEBPACK_IMPORTED_MODULE_9___default()(clickedVideoIds, contentId)) {
          (0,_surfline_web_common__WEBPACK_IMPORTED_MODULE_17__/* .trackEvent */ .L9)('Played Video', {
            title: title,
            contentId: contentId,
            category: segmentCategory
          });
          _this.setState(function (prevState) {
            return {
              clickedVideoIds: prevState.clickedVideoIds.concat([contentId])
            };
          });
        }
      };
    });
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this), "className", function () {
      var _this$props = _this.props,
        premium = _this$props.premium,
        expert = _this$props.expert,
        showPaywall = _this$props.showPaywall;
      var showMore = _this.state.showMore;
      return classnames__WEBPACK_IMPORTED_MODULE_10___default()({
        'quiver-forecast-article-card': true,
        'quiver-forecast-article-card--premium': premium,
        'quiver-forecast-article-card--expert': expert,
        'quiver-forecast-article-card--show-more': _this.showAll || showMore,
        'quiver-forecast-article-card--paywall': showPaywall
      });
    });
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this), "meta", function () {
      var _this$props2 = _this.props,
        author = _this$props2.author,
        premium = _this$props2.premium,
        expert = _this$props2.expert,
        publishedDateTime = _this$props2.publishedDateTime;
      return "\n      ".concat(author ? "By ".concat(author, " \u2022 ") : '', "\n      ").concat(premium ? 'Premium ' : '', "\n      ").concat(expert ? 'Expert Forecast •' : '', "\n      ").concat(publishedDateTime, "\n    ");
    });
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this), "toggleShowMore", function () {
      return _this.setState(function (prevState) {
        return {
          showMore: !prevState.showMore
        };
      });
    });
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this), "checkShouldShowAll", function () {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var matchedImages = content ? content.match(/<img/gi) : [];
      if (matchedImages && matchedImages.length > 1) return false;
      var chCount = content ? content.replace(/(<([^>]+)>)/gi, '').length : 0;
      return chCount < 400;
    });
    _this.showAll = props.showFullArticle || _this.checkShouldShowAll(props.body);
    _this.state = {
      showMore: false,
      clickedVideoIds: []
    };
    return _this;
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(ForecastArticleCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var vidTags = document.getElementsByTagName('video');
      if (vidTags.length) {
        var videos = (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(vidTags);
        videos.forEach(function (vid) {
          _this2.applyVideoEvent(vid);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        premium = _this$props3.premium,
        id = _this$props3.id,
        title = _this$props3.title,
        body = _this$props3.body,
        tags = _this$props3.tags,
        showPaywall = _this$props3.showPaywall,
        onClickReadMore = _this$props3.onClickReadMore,
        onClickShareArticle = _this$props3.onClickShareArticle,
        funnelUrl = _this$props3.funnelUrl,
        onClickPaywall = _this$props3.onClickPaywall,
        fbAppId = _this$props3.fbAppId,
        url = _this$props3.url,
        showShare = _this$props3.showShare,
        CustomPaywallCTA = _this$props3.CustomPaywallCTA;
      var showMore = this.state.showMore;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default().createElement("div", {
        className: this.className(premium)
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default().createElement(_BaseContentCard_BaseContentCard_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
        meta: this.meta(),
        tags: tags.map(function (_ref) {
          var name = _ref.name;
          return {
            name: name
          };
        }),
        showPaywall: showPaywall
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default().createElement(_ForecastArticleBody_ForecastArticleBody_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
        id: id,
        title: title,
        body: body,
        showMore: showMore,
        fbAppId: fbAppId,
        url: url,
        showShare: showShare,
        onClickShareArticle: onClickShareArticle,
        showPaywall: showPaywall,
        onClickReadMore: onClickReadMore,
        funnelUrl: funnelUrl,
        onClickPaywall: onClickPaywall,
        showAll: this.showAll,
        toggleShowMore: this.toggleShowMore,
        CustomPaywallCTA: CustomPaywallCTA
      })));
    }
  }]);
  return ForecastArticleCard;
}(react__WEBPACK_IMPORTED_MODULE_7__.Component);
ForecastArticleCard.defaultProps = {
  author: null,
  id: null,
  premium: false,
  body: null,
  showPaywall: false,
  showFullArticle: false,
  funnelUrl: null,
  onClickPaywall: null,
  onClickReadMore: null,
  onClickShareArticle: null,
  expert: false,
  segmentCategory: null,
  fbAppId: null,
  url: null,
  showShare: true,
  CustomPaywallCTA: null
};
var ForecastArticleCard$1 = ForecastArticleCard;


//# sourceMappingURL=ForecastArticleCard.js.map


/***/ }),

/***/ 21080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getClientIp$1; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23123);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1__);
/**
 * @surfline/web-common v18.1.5 2023-12-14
 */




/**
 * @param {import('express').Request} req
 * @returns {string | undefined | null}
 */
var getClientIp = function getClientIp(req) {
  var clientIp;
  if (req && req.headers) {
    var ip = req.headers['x-forwarded-for'] || req.connection.remoteAddress;

    // in dev, loopback is sometimes an ipv6 address... downstream services
    // don't handle that well.
    if (ip === '::1') ip = '8.8.8.8';
    clientIp = ip ? ip.split(',')[0] : null;
  }
  return clientIp;
};
var getClientIp$1 = getClientIp;


//# sourceMappingURL=getClientIp.js.map


/***/ }),

/***/ 82268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ cloneObject; }
/* harmony export */ });
/* harmony import */ var _assign_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52149);

function cloneObject(object) {
  return (0,_assign_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, object);
}

/***/ }),

/***/ 49474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ compareAsc; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/***/ }),

/***/ 12195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatDistanceStrict; }
/* harmony export */ });
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24262);
/* harmony import */ var _compareAsc_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49474);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19013);
/* harmony import */ var _lib_cloneObject_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82268);
/* harmony import */ var _lib_assign_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52149);
/* harmony import */ var _lib_defaultLocale_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44941);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);








var MILLISECONDS_IN_MINUTE = 1000 * 60;
var MINUTES_IN_DAY = 60 * 24;
var MINUTES_IN_MONTH = MINUTES_IN_DAY * 30;
var MINUTES_IN_YEAR = MINUTES_IN_DAY * 365;

/**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */

function formatDistanceStrict(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale, _options$roundingMeth;
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _lib_defaultLocale_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
  if (!locale.formatDistance) {
    throw new RangeError('locale must contain localize.formatDistance property');
  }
  var comparison = (0,_compareAsc_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dirtyDate, dirtyBaseDate);
  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }
  var localizeOptions = (0,_lib_assign_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_lib_cloneObject_index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison: comparison
  });
  var dateLeft;
  var dateRight;
  if (comparison > 0) {
    dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(dirtyBaseDate);
    dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(dirtyDate);
  } else {
    dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(dirtyDate);
    dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(dirtyBaseDate);
  }
  var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : 'round');
  var roundingMethodFn;
  if (roundingMethod === 'floor') {
    roundingMethodFn = Math.floor;
  } else if (roundingMethod === 'ceil') {
    roundingMethodFn = Math.ceil;
  } else if (roundingMethod === 'round') {
    roundingMethodFn = Math.round;
  } else {
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  }
  var milliseconds = dateRight.getTime() - dateLeft.getTime();
  var minutes = milliseconds / MILLISECONDS_IN_MINUTE;
  var timezoneOffset = (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(dateRight) - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(dateLeft);

  // Use DST-normalized difference in minutes for years, months and days;
  // use regular difference in minutes for hours, minutes and seconds.
  var dstNormalizedMinutes = (milliseconds - timezoneOffset) / MILLISECONDS_IN_MINUTE;
  var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
  var unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = 'second';
    } else if (minutes < 60) {
      unit = 'minute';
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'hour';
    } else if (dstNormalizedMinutes < MINUTES_IN_MONTH) {
      unit = 'day';
    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
      unit = 'month';
    } else {
      unit = 'year';
    }
  } else {
    unit = String(defaultUnit);
  }

  // 0 up to 60 seconds
  if (unit === 'second') {
    var seconds = roundingMethodFn(milliseconds / 1000);
    return locale.formatDistance('xSeconds', seconds, localizeOptions);

    // 1 up to 60 mins
  } else if (unit === 'minute') {
    var roundedMinutes = roundingMethodFn(minutes);
    return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions);

    // 1 up to 24 hours
  } else if (unit === 'hour') {
    var hours = roundingMethodFn(minutes / 60);
    return locale.formatDistance('xHours', hours, localizeOptions);

    // 1 up to 30 days
  } else if (unit === 'day') {
    var days = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions);

    // 1 up to 12 months
  } else if (unit === 'month') {
    var months = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH);
    return months === 12 && defaultUnit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions);

    // 1 year up to max Date
  } else if (unit === 'year') {
    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
    return locale.formatDistance('xYears', years, localizeOptions);
  }
  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}

/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 47415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 64721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118),
    isArrayLike = __webpack_require__(98612),
    isString = __webpack_require__(47037),
    toInteger = __webpack_require__(40554),
    values = __webpack_require__(52628);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 40554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(18601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 52628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseValues = __webpack_require__(47415),
    keys = __webpack_require__(3674);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 34513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTimeoutFn; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useTimeoutFn(fn, ms) {
    if (ms === void 0) { ms = 0; }
    var ready = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var timeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var callback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
    var isReady = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () { return ready.current; }, []);
    var set = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            ready.current = true;
            callback.current();
        }, ms);
    }, [ms]);
    var clear = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        callback.current = fn;
    }, [fn]);
    // set on mount, clear on unmount
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        set();
        return clear;
    }, [ms]);
    return [isReady, clear, set];
}


/***/ })

}]);